import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import RTFRTextBlock from "../components/refrigerated-truck-for-rent/RTFRTextBlock";
import RTFRIndustries from "../components/refrigerated-truck-for-rent/RTFRIndustries";
import RTFRPricing from "../components/refrigerated-truck-for-rent/RTFRPricing";
import RTFRFaq from "../components/refrigerated-truck-for-rent/RTFRFaq";

import { refrigeratedTruckForRentSections } from "../components/refrigerated-truck-for-rent/refrigeratedTruckForRentSections";
import "../components/refrigerated-truck-for-rent/refrigerated-truck-for-rent.css";

const RefrigeratedTruckForRent = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "rtfr-hero":
        return (
          <ContactHero
            key={index}
            variant="refrigerated-truck-for-rent"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "rtfr-covers":
        return (
          <RTFRTextBlock
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            imageSide={section.imageSide}
          />
        );

      case "rtfr-industries":
        return (
          <RTFRIndustries
            key={index}
            title={section.title}
            industries={section.industries}
          />
        );

      case "rtfr-fleet":
        return (
          <RTFRTextBlock
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            imageSide={section.imageSide}
          />
        );

      case "rtfr-operations":
        return (
          <RTFRTextBlock
            key={index}
            variant="alt"
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            imageSide={section.imageSide}
          />
        );

      case "rtfr-pricing":
        return (
          <RTFRPricing
            key={index}
            title={section.title}
            descriptionMain={section.descriptionMain}
            rows={section.rows}
            descriptionNote={section.descriptionNote}
          />
        );

      case "rtfr-coverage":
        return (
          <RTFRTextBlock
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            imageSide={section.imageSide}
          />
        );

      case "rtfr-faq":
        return (
          <RTFRFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Refrigerated Trucks for Rent in Dubai | Chiller Fleet Transport</title>
        <meta
          name="description"
          content="Chiller Fleet Transport offers refrigerated trucks for rent in Dubai & Sharjah for chilled and frozen cargo across UAE with payload capacity of 3 to 15 tons. Hire today."
        />
        <link rel="canonical" href="https://chillerfleet.com/refrigerated-trucks-for-rent" />
        <meta property="og:title" content="Refrigerated Trucks for Rent in Dubai | Chiller Fleet Transport" />
        <meta
          property="og:description"
          content="Chiller Fleet Transport offers refrigerated trucks for rent in Dubai & Sharjah for chilled and frozen cargo across UAE with payload capacity of 3 to 15 tons. Hire today."
        />
        <meta property="og:url" content="https://chillerfleet.com/refrigerated-trucks-for-rent" />
        <meta name="twitter:title" content="Refrigerated Trucks for Rent in Dubai | Chiller Fleet Transport" />
        <meta
          name="twitter:description"
          content="Chiller Fleet Transport offers refrigerated trucks for rent in Dubai & Sharjah for chilled and frozen cargo across UAE with payload capacity of 3 to 15 tons. Hire today."
        />
      </Helmet>

      {refrigeratedTruckForRentSections.map(renderSection)}
    </>
  );
};

export default RefrigeratedTruckForRent;
